document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collection-facets__mobile-filter[data-filter="price"] .facets__clear-button, .collection-facets__mobile-filter[data-filter="price"] .filter-clear').forEach(clearButton => {
    clearButton.addEventListener('click', function(event) {
      event.preventDefault();
      
      const priceFilter = this.closest('.collection-facets__mobile-filter[data-filter="price"]');
      
      priceFilter.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.checked = false;
      });
      
      priceFilter.querySelectorAll('input[type="number"]').forEach(input => {
        input.value = '';
      });
      
    });
  });
  
  document.querySelectorAll('.collection-facets__mobile-filter .filter-clear').forEach(clearButton => {
    clearButton.addEventListener('click', function(event) {
      if (!this.closest('.collection-facets__mobile-filter[data-filter="price"]')) {
        event.preventDefault();
        
        const filter = this.closest('.collection-facets__mobile-filter');
        
        filter.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
          checkbox.checked = false;
        });
        
      }
    });
  });
  
  document.querySelector('.collection-facets__mobile-drawer-buttons button[data-action="update"]')?.addEventListener('click', function() {
    const form = document.querySelector('.collection-facets__mobile-drawer').closest('form');
    if (form) {
      form.submit();
    }
  });
  
  document.querySelector('.collection-facets__mobile-drawer-buttons button[data-action="clear"]')?.addEventListener('click', function() {
    document.querySelectorAll('.collection-facets__mobile-filter input[type="checkbox"], .collection-facets__mobile-filter input[type="radio"]').forEach(input => {
      input.checked = false;
    });
    
    document.querySelectorAll('.collection-facets__mobile-filter input[type="number"], .collection-facets__mobile-filter input[type="text"]').forEach(input => {
      input.value = '';
    });
    
  });
}); 